module.exports = __webpack_public_path__ + "img/gnu_smart_gallery3.c0a42168.jpg";